// @flow
import * as React from 'react';

import { TRANSITION_ENTER_DURATION, TRANSITION_EXIT_DURATION } from './constants';

import { StyledCSSTransition } from './styles';

type Props = {
    children: React.Node,
    in?: boolean
};

export default ({ children, in: inProp }: Props) => (
    <StyledCSSTransition
        classNames="fade"
        in={inProp}
        timeout={{ enter: TRANSITION_ENTER_DURATION, exit: TRANSITION_EXIT_DURATION }}
        unmountOnExit
    >
        {children}
    </StyledCSSTransition>
);



// WEBPACK FOOTER //
// ./src/components/routing/page-transition/index.js